export { default } from './InfoSection';
